import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store'
import 'material-icons/iconfont/material-icons.css'
import {sync} from 'vuex-router-sync'
import setupRoute from './router/setup'
import setupApi from './api/setup'
import setupPlugins from './plugins/setup'

Vue.config.productionTip = false

sync(store, router)
setupRoute()
setupApi()
setupPlugins()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  // 注入路由
  router,
  // 注入vuex的store
  store,
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js